/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for next icon.
 *
 * @author Hari Gangadharan
 */
const ChevronNext = props => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      d="M4.2506,17.6606035 C3.8876,17.2486035 3.9236,16.6116035
      4.3376,16.2436035 L12.4906,8.9996035 L4.3376,1.7566035
      C3.9226,1.3896035 3.8866,0.752603504 4.2506,0.339603504
      C4.6166,-0.0763964961 5.2486,-0.115396496 5.6616,0.252603504
      L14.6616,8.2476035 C14.8766,8.4376035 14.9996,8.7126035
      14.9996,8.9996035 C14.9996,9.2876035 14.8766,9.5616035
      14.6616,9.7526035 L5.6616,17.7476035 C5.2486,18.1156035
      4.6166,18.0766035 4.2506,17.6606035"
    />
  </SvgIcon>
);

export default ChevronNext;



// WEBPACK FOOTER //
// ./src/js/icons/ChevronNext.jsx